import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useDictionary } from "hooks";
import { MAXIMUM_BY_CLASSIFICATION_CODE_TYPE } from "globals/constants";

import styles from "./styles.css";


const ClassificationCodeNumberOfCodesInput = ({
	type,
	codeType,
	value,
	defaultValue,
	disabled,
	name,
	onChange,
	maximum,
	minimum,
}) => {
	const dictionary = useDictionary("simplifiedBuilder.components.classificationCodeSettings.errors");

	const [error, setError] = useState("");

	useEffect(() => {
		setError(validate(type, maximum, minimum));
	}, [ maximum, minimum ]);

	const validate = useCallback((type, max, min) => {
		if (type === "maximum") {
			if (max <= 0 || max > MAXIMUM_BY_CLASSIFICATION_CODE_TYPE[codeType]) {
				return dictionary.wrongRangeByCodeType[codeType]
					|| `This number must be between 1 - ${MAXIMUM_BY_CLASSIFICATION_CODE_TYPE[codeType]}`;
			} else if (max < min) {
				return dictionary.wrongMaxValue || "Maximum number must be larger than the minimum number";
			}
		} else if (type === "minimum") {
			if (min <= 0 || min > MAXIMUM_BY_CLASSIFICATION_CODE_TYPE[codeType]) {
				return dictionary.wrongRangeByCodeType[codeType]
					|| `This number must be between 1 - ${MAXIMUM_BY_CLASSIFICATION_CODE_TYPE[codeType]}`;
			}
			else if (min > max) {
				return dictionary.wrongMinValue || "Minimum number must be less than the maximum number";
			}
		}
		return "";
	}, [ codeType ]);

	const handleChange = (event) => {
		// strips all non-numbers + converts number string to number ("5asdf9.6%" -> 596)
		let inputValue = +(event.target.value.replace(/\D/g,""));
		// if the int is over 100, reduce it down a power (596 -> 59)
		if (inputValue > 100) {
			inputValue = Math.floor(inputValue / 10);
		}

		onChange(name, inputValue);
	};

	return (
		<>
			<input
				type="text"
				value={value}
				defaultValue={defaultValue}
				disabled={disabled}
				onChange={handleChange}
				data-error={!!error}
				className={styles.numberOfCodeInput}
			/>
			{!!error && <span className={styles.numberOfCodeError}>{error}</span>}
		</>
	);
};


ClassificationCodeNumberOfCodesInput.propTypes = {
	type: PropTypes.oneOf([ "minimum", "maximum" ]).isRequired,
	codeType: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
	defaultValue: PropTypes.number,
	disabled: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	minimum: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
	maximum: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
};

export default ClassificationCodeNumberOfCodesInput;
